import { useState } from 'react';
import { skills as SKILLS } from '../data';
import s from './Skills.module.css';

export default function Skills() {
  const cats = Object.keys(SKILLS);
  const [active, setActive] = useState(cats[0]);
  return (
    <section id="skills" className="sec" aria-label="Skills">
      <div className="sec-inner">
        <div className="sec-top">
          <div><div className="sec-num">02 — Skills</div><h2 className="sec-h">Tech Stack</h2></div>
          <p className="sec-p">Tools I use to build fast, scalable, maintainable products.</p>
        </div>
        <div className={s.tabs}>
          {cats.map(c => (
            <button key={c} className={`${s.tab} ${active===c?s.active:''}`} onClick={()=>setActive(c)}>{c}</button>
          ))}
        </div>
        <div className={s.pills}>
          {SKILLS[active].map(sk => <div key={sk} className={s.pill}>{sk}</div>)}
        </div>
      </div>
    </section>
  );
}
